import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'app/@core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginHistoryService {

  private END_POINT = '';

  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) {
    this.END_POINT = `${this.config.get().BASE_URL}/v1/LoginHistory/login-history`;
  }
  
updateLogoutTime(payload: { id: number; logoutTime: string }): Observable<any> {
  console.log("payload-", payload);

  const url = `${this.END_POINT}/update-logout-time`;

  return this.http.put(url, payload);
}
}